import { Component, OnInit } from '@angular/core';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {ActivatedRoute} from '@angular/router';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {ConsuntivoChargesModel} from '../../../models/ConsuntivoChargesModel';
import {ProviderModel} from '../../../models/ProviderModel';

@Component({
  selector: 'app-charges-by-reference-month',
  templateUrl: './charges-by-reference-month.component.html',
  styleUrls: ['./charges-by-reference-month.component.scss']
})
export class ChargesByReferenceMonthComponent extends BaseGeneralComponent implements OnInit {
  filter: ConsuntivoChargesModel = new ConsuntivoChargesModel();
  providerSelected: ProviderModel;
  reportSection: boolean;
  numAnnoMeseData: string[] = [];

  constructor(
    private _activatedRoute: ActivatedRoute,
    private numAnnoMeseService: NumAnnoMeseService,
    private loaderService: LoaderService
  ) {
    super();
  }

  ngOnInit() {
    this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    this.filter.provider = this.providerSelected;
    this._activatedRoute.queryParams.subscribe(params => {
      this.reportSection = params['reportSection'];
    });

    this.numAnnoMeseService.getAllMonth(this.filter.provider, this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        const providerDefault = this.filter.provider;
        this.numAnnoMeseData = this.filterFromDxc(providerDefault, resultYearMonth);

        if (!this.filter.numAnnoMese) {
          this.numAnnoMeseService.getLastConsumptiveVolMonth(this.providerSelected).subscribe(
            res => {
              this.filter.numAnnoMese = res;
              if (this.reportSection) {
                this.showFilter = true;
              } else {
                // this.getDataPage(this.offset, this.filter);
              }
            }
          );
        } else {
          if (!this.reportSection) {
            // this.showFilter = false;
            // this.getDataPage(this.offset, this.filter);
          } else {
            this.showFilter = true;
          }
        }
      },
      error => {
        console.log(error);
        this.loaderService.display(false);
      });
  }

}
